import script from "./CustomQSeparator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomQSeparator.vue?vue&type=script&setup=true&lang=ts"

import "./CustomQSeparator.vue?vue&type=style&index=0&id=7bbe10a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbe10a7"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
